<template>
  <nuttrema-layout-form-standard
     theme="west-top"
    :edit="true"
    :saveError="PersonAssignProgram.saveError">

    <template slot="center">
      <east-block-product-detail :programDetails="ProgramDetails.data"></east-block-product-detail>

      <el-form
         label-position="top"
        :rules="rules"
        :ref="formRef"
        :model="formData">

        <section>
          <h4 class="section-title">{{ $t('label.participant') }}</h4>
          <div class="section-items is-info-card">
            <user-info-small-card
               class="is-in-section"
              :reactive="false"
              :personDetails="PersonDetails.data">
            </user-info-small-card>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.create_new_assigned_program') }}</h4>
          <div class="section-items">
            <el-form-item
               prop="name"
              :label="$t('label.name')">
              <el-col :span="24">
                <el-input
                  v-model="formData.name"
                  class="w-100">
                </el-input>
              </el-col>
            </el-form-item>

            <el-row>
              <el-col :span="11">
                <el-form-item
                   prop="start_date"
                  :label="$t('label.start_date')">
                  <el-date-picker
                     class="w-100"
                     v-model="formData.start_date"
                     type="date"
                     format="dd/MM/yyyy"
                     value-format="yyyy-MM-dd"
                    :picker-options="options.start_date">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="2">
                <el-form-item
                  :label="$t('label.end_date')">
                  <el-date-picker
                    class="w-100"
                    v-model="endDate"
                    disabled
                    type="date"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

        </section>

      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">
        <el-button type="primary" size="small" :loading="isSaving" @click="submitForm">{{ $t('label.assign') }}</el-button>
        <el-button type="text" size="small" @click="handleCancelClick">{{ $t('label.cancel') }}</el-button>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import moment from 'moment';
import { get, includes } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import UserInfoSmallCard from 'components/ui/card/user-info-small-card';
import EastBlockProductDetail from 'components/pages/professional/programs/shared/details/cmpt-east-block-product-detail';

export default {
  name: 'form-participant-assign-program',
  mixins: [
    FormStandardBehavior,
  ],
  components: {
    UserInfoSmallCard,
    EastBlockProductDetail,
    NuttremaLayoutFormStandard,
  },
  props: {
    id: {
      required: true,
      default: null,
    },
    programID: {
      required: true,
      default: null,
    },
    PersonDetails: {
      required: true,
      default: null,
    },
    ProgramDetails: {
      required: true,
      default: null,
    },
    PersonOccupiedDates: {
      required: true,
      default: null,
    },
    PersonAssignProgram: {
      required: false,
    },
  },
  data() {
    return {
      options: {
        start_date: {
          disabledDate: this.disabledDate,
        },
      },
      formData: {
        name: null,
        program_id: null,
        start_date: moment().add(1, 'day').toDate(),
        // price: null,
        // currency: 'eur',
        // payment_status: false,
      },
      rules: {
        name: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.name', true),
          },
        ],
      },
    };
  },
  computed: {
    endDate() {
      const duration = get(this.ProgramDetails, 'data.duration', 0);
      return moment(this.formData.start_date).add(duration - 1, 'days').toDate();
    },
  },
  methods: {
    disabledDate(time) {
      const inPast = time.getTime() < moment().subtract(1, 'day').toDate();
      const occupiedDates = get(this.PersonOccupiedDates, 'data', []);
      const wasOccupied = includes(occupiedDates, moment(time).format('YYYY-MM-DD'));
      return inPast || wasOccupied;
    },
    getFormData() {
      const payload = this.cloneDeep(this.formData);
      return this.removeEmpty(payload);
    },
    setFormData() {
      this.formData.program_id = this.programID;
    },
    handleCancelClick() {
      this.$emit('back');
    },
  },
  created() {
    this.stateData = this.PersonAssignProgram;
    this.formRef = 'form-participant-assign-program';
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/assigned-programs/form-participant-assign-program.vue